import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs font-semibold uppercase tracking-wide text-dashboard-muted mb-2 flex items-center gap-1.5" }
const _hoisted_2 = { class: "bg-dashboard-bg rounded-lg p-3 space-y-1.5 text-sm" }


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailSection',
  props: {
    title: {},
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h3", _hoisted_1, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
            key: 0,
            class: "w-3.5 h-3.5"
          }))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})